// App-side delegate for `@heidi/commerce/data` (D2, ARCFE-972). The mutation
// moved; this file keeps the name, the signature, and every user-visible
// effect — the ratified ARCFE-921 shape.
//
// `trialType` never crossed the seam: it selected a toast description and
// nothing else, so the branch stays here with the copy it chooses between.
import { logger } from '@/utils/logger/logger';
import { useMutateRevertReverseTrial as useMutateRevertReverseTrialCore } from '@heidi/commerce/data';
import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import { invalidateCurrentUser } from '../query/useQueryUser';
import { invalidateCurrentUserBillingInfo } from '../query/useQueryUserBillingInfo';

type TrialType = 'pro' | 'practice';

export function useMutateRevertReverseTrial(trialType: TrialType = 'pro') {
  const { t } = useTranslations();

  const description =
    trialType === 'practice'
      ? t('revertTrialToast.descriptionPractice')
      : t('revertTrialToast.descriptionPro');

  return useMutateRevertReverseTrialCore({
    onRevertSuccess: () => {
      void invalidateCurrentUser();
      void invalidateCurrentUserBillingInfo();
      toast({
        title: t('revertTrialToast.title'),
        description,
      });
    },
    onRevertError: (error) => {
      logger.error('Error reverting trial:', error);
      toast({
        tone: 'destructive',
        title: t('revertTrialToast.errorTitle'),
        description: t('revertTrialToast.errorDescription'),
      });
    },
  });
}
